/**
 * 非同期処理を開始順で世代管理し、最新の要求だけが結果を反映できるようにする。
 */
export function createLatestRequestGuard() {
	let latestGeneration = 0;

	return {
		begin: () => {
			const generation = ++latestGeneration;
			return () => generation === latestGeneration;
		},
	};
}
